'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485 from "./presto.types$-Proxy-Name$$anon$85.js";
var $p;
/** @constructor */
function $c_Lpresto_types$ProxyName$() {
  this.c8L = null;
  this.c8M = false;
  this.c8J = null;
  this.c8K = false;
  this.c8P = null;
  this.c8Q = false;
  this.c8N = null;
  this.c8O = false;
}
export { $c_Lpresto_types$ProxyName$ as $c_Lpresto_types$ProxyName$ };
$p = $c_Lpresto_types$ProxyName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$ProxyName$;
/** @constructor */
function $h_Lpresto_types$ProxyName$() {
}
export { $h_Lpresto_types$ProxyName$ as $h_Lpresto_types$ProxyName$ };
$h_Lpresto_types$ProxyName$.prototype = $p;
$p.cs9 = (function() {
  if ((!this.c8M)) {
    this.c8L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c8M = true;
  }
  return this.c8L;
});
$p.adx = (function() {
  if ((!this.c8K)) {
    this.c8J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8K = true;
  }
  return this.c8J;
});
$p.csl = (function() {
  if ((!this.c8Q)) {
    this.c8P = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c8Q = true;
  }
  return this.c8P;
});
$p.cIG = (function() {
  if ((!this.c8O)) {
    this.c8N = new $j_presto$002etypes$0024$002dProxy$002dName$0024$0024anon$002485.$c_Lpresto_types$ProxyName$$anon$85(this);
    this.c8O = true;
  }
  return this.c8N;
});
var $d_Lpresto_types$ProxyName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$ProxyName$, "presto.types$ProxyName$", ({
  a0S: 1,
  D: 1
}));
export { $d_Lpresto_types$ProxyName$ as $d_Lpresto_types$ProxyName$ };
var $n_Lpresto_types$ProxyName$;
function $m_Lpresto_types$ProxyName$() {
  if ((!$n_Lpresto_types$ProxyName$)) {
    $n_Lpresto_types$ProxyName$ = new $c_Lpresto_types$ProxyName$();
  }
  return $n_Lpresto_types$ProxyName$;
}
export { $m_Lpresto_types$ProxyName$ as $m_Lpresto_types$ProxyName$ };
//# sourceMappingURL=presto.types$-Proxy-Name$.js.map
